export default {"src":"https://s.sylndr.com/c-63dea61/_next/static/media/MoneyBackBadge.0fbe934e.svg","height":120,"width":121,"blurWidth":0,"blurHeight":0};